import { PropsWithChildren } from 'react'
import { NativeBridge, NativeFrameConfig } from '@dhl/native-bridge'
import { useColorScheme } from '@dhl/theme'
import { PATH } from '~/links'
import { getConfig } from './config'

const { environment } = getConfig()

const nativeFrame: NativeFrameConfig = {
  defaultStatusBarColor: 'none',
  paths: [{ pattern: `/${PATH.ROOT_PWA}*`, statusBar: 'brand' }],
}

export const PwaOtcNativeBridge = ({ children }: PropsWithChildren) => {
  const { preferredColorScheme, setPaletteMode } = useColorScheme()

  return (
    <NativeBridge
      isProduction={environment === 'production'}
      nativeFrame={nativeFrame}
      theme={{ preferredColorScheme, setPaletteMode }}
    >
      {children}
    </NativeBridge>
  )
}
